export function Notes({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.50004 4.24999C7.25004 4.75832 7.05004 5.37499 6.88337 6.08332L6.06671 9.57499C5.25004 13.0583 6.32504 14.775 9.80004 15.6L11.2 15.9333C11.6834 16.05 12.1334 16.125 12.55 16.1583C15.15 16.4083 16.5334 15.1917 17.2334 12.1833L18.05 8.69999C18.8667 5.21665 17.8 3.49165 14.3084 2.67499L12.9167 2.34999C10.1334 1.69165 8.47504 2.23332 7.50004 4.24999ZM12.55 16.1583C12.0334 16.5083 11.3834 16.8 10.5917 17.0583L9.27504 17.4917C5.96671 18.5583 4.22504 17.6667 3.15004 14.3583L2.08337 11.0667C1.01671 7.75832 1.90004 6.00832 5.20837 4.94165L6.52504 4.50832C6.86671 4.39999 7.19171 4.30832 7.50004 4.24999"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
